import { Navigate } from "react-router-dom";
import { useVisitorRole } from "../../utils/useVisitorRole";

/** Sends old visitor URLs to the single register or control page. */
export default function VisitorLegacyRedirect({ hash = "" }) {
  const perms = useVisitorRole();
  const base = perms.isAdmin ? "/app/visitors/control" : "/app/visitors";
  const suffix = hash ? (hash.startsWith("#") ? hash : `#${hash}`) : "";
  return <Navigate to={`${base}${suffix}`} replace />;
}
